import { i18n } from '@/locales';

const isEmailString = {
  message: () => i18n.t('Please enter a valid email.If more than one then they must be separated by a comma'),
  validate(emailStr) {
    let emails = emailStr.split(',');
    let isValid = true;
    emails.forEach(email => {
      if (!validateEmail(email.trim())) {
        isValid = false;
      }
    });
    return isValid;
  }
};

function validateEmail(email) {
  return  /^([\w-+.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/.test(email);
}

export default isEmailString;